/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _5 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>5 - Обработка ошибок рендера</h2>
    <p className={styles.description}>
      React очень любит класть все приложение при любой ошибке. Метод{' '}
      <code className={styles.code}>componentDidCatch</code> срабатывает при ошибке в дочернем компоненте и позволяет
      родительским компонентам отлавливать ошибки в детях, отображая запасной интерфейс. В результате, при ошибке,
      интерфейс не падает.{' '}
    </p>
    <CopyBlock text={`componentDidCatch(error, info) {}`} language="javascript" showLineNumbers={false} theme={ocean} />
    <ul className={styles.list}>
      <li className={styles.list__item}>Используется для контроля ошибок</li>
      <li className={styles.list__item}>Ловит ошибки только в детях, но не в самом родителе</li>
      <li className={styles.list__item}>
        <code className={styles.code}>error</code> - результат <code className={styles.code}>toString()</code> объекта
        ошибки
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>info</code> - объект описывающий stack trace
      </li>
    </ul>
    <CopyBlock
      text={`class ErrorBoundary extends React.Component {
  state = { hasError: false };

  componentDidCatch(error, info) {
    // Если метод был вызван значит есть ошибка!
    // Устанавливаем состояние
    this.setState({ hasError: true });
    // Также можно отправить отчет об ошибке вашему аналитическому сервису
    // logErrorToMyService(error, info);
  }

  render() {
    // Если есть ошибка...
    if (this.state.hasError) {
      // Рендерим fallback UI
      return <h1>Something went wrong, please try again later :(</h1>;
    }

    // Если все ок, рендерим детей
    return this.props.children;
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
